<template>
  <div class="page flex-col">
    <AppHeader />
    <div class="block_1 flex-col">
      <AnnouncementBar />
      <ServiceGrid />
      <SectionTitle title="党在我心中，青山绿水行" :link="`/article-list?categoryId=${getColumnIdByName('青山绿水')}`" />
      <NewsList :items="qslsList" />
      <SectionTitle title="生态智慧应急" :link="`/article-list?categoryId=${getColumnIdByName('智慧应急')}`" />
      <NewsList :items="zhiyingList" />
      <SectionTitle title="时政要闻" :link="`/article-list?categoryId=${getColumnIdByName('时政要闻')}`" />
    </div>
    <div class="text-wrapper_1 flex-col" v-if="shizhengTop.title || shizhengList.length > 0" @click="goDetail(shizhengTop)">
      <div class="highlight-box">
        <img class="highlight-bg" :src="shizhengTop.img" />
      </div>
      <span class="text_11">{{ shizhengTop.title }}</span>
    </div>
    <NewsArticleBlock :items="shizhengList" />
    <div class="block_3 flex-col">
      <SectionTitle title="精彩视频"  class="resetClass"/>
      <VideoGallery :items="videoList" />
      <SectionTitle title="精彩图集"  class="resetClass"/>
      <PhotoGallery :items="photoList" />
      <SectionTitle title="智库专家" class="resetClass" :link="`/article-list?categoryId=${getColumnIdByName('智库专家')}`" />
      <ExpertThinkTank :experts="expertList" />
      <!-- <SupervisingUnits :items="supervisingList" /> -->
      <SearchBar />
      <BackTop />
      <CopyrightFooter />
    </div>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AnnouncementBar from './components/AnnouncementBar.vue'
import ServiceGrid from './components/ServiceGrid.vue'
import NewsList from './components/NewsList.vue'
import NewsArticleBlock from './components/NewsArticleBlock.vue'
import VideoGallery from './components/VideoGallery.vue'
import PhotoGallery from './components/PhotoGallery.vue'
import ExpertThinkTank from './components/ExpertThinkTank.vue'
// import SupervisingUnits from './components/SupervisingUnits.vue'
import SearchBar from './components/SearchBar.vue'
import CopyrightFooter from './components/CopyrightFooter.vue'
import SectionTitle from './components/SectionTitle.vue'
import BackTop from './components/BackTop.vue'
import { contentList } from '../api/content'
import { getColumnIdByName } from '../utils/common'

export default {
  components: {
    AppHeader,
    AnnouncementBar,
    ServiceGrid,
    NewsList,
    NewsArticleBlock,
    VideoGallery,
    PhotoGallery,
    ExpertThinkTank,
    // SupervisingUnits,
    SearchBar,
    CopyrightFooter,
    SectionTitle,
    BackTop
  },
  data() {
    return {
      qslsList: [],
      zhiyingList: [],
      shizhengTop: {},
      shizhengList: [],
      expertList: [],
      videoList: [],
      photoList: [],
      supervisingList: []
    }
  },
  mounted() {
    this.loadAll()
    document.title = '生态保护与法治报道中心'
  },
  methods: {
    getColumnIdByName,
    async loadAll() {
      await Promise.all([
        this.loadQsls(),
        this.loadZhiying(),
        this.loadShizheng(),
        this.loadExperts(),
        this.loadVideo(),
        this.loadPhoto(),
        this.loadSupervising()
      ])
    },
    async loadQsls() {
      const categoryId = getColumnIdByName('青山绿水')
      if (!categoryId) return
      try {
        const data = await contentList({ categoryId, pageNum: 1, pageSize: 5 })
        const rows = data.rows || []
        this.qslsList = rows.map(item => ({
          ...item,
          thumb: item.thumb || item.cover || item.thumbnail || '',
          img: item.litpic ? JSON.parse(item.litpic)[0].url : ''
        }))
      } catch (e) {
        console.error('获取青山绿水失败', e)
      }
    },
    async loadZhiying() {
      const categoryId = getColumnIdByName('智慧应急')
      if (!categoryId) return
      try {
        const data = await contentList({ categoryId, pageNum: 1, pageSize: 5 })
        const rows = data.rows || []
        this.zhiyingList = rows.map(item => ({
          ...item,
          img: item.litpic ? JSON.parse(item.litpic)[0].url : ''
        }))
      } catch (e) {
        console.error('获取智慧应急失败', e)
      }
    },
    async loadShizheng() {
      const categoryId = getColumnIdByName('时政要闻')
      if (!categoryId) return
      try {
        const data = await contentList({ categoryId, pageNum: 1, pageSize: 6 })
        const rows = data.rows || [] 
        this.shizhengList = rows.slice(1).map(item => ({
          ...item,
          thumb: item.thumb || item.cover || item.thumbnail || '',
          img: item.litpic ? JSON.parse(item.litpic)[0].url : ''
        }))
        this.shizhengTop = this.shizhengList[0] || {}
      } catch (e) {
        console.error('获取时政要闻失败', e)
      }
    },
    async loadExperts() {
      const categoryId = getColumnIdByName('智库专家')
      if (!categoryId) return
      try {
        const data = await contentList({ categoryId, pageNum: 1, size: 10 })
        const rows = data.rows || []
        this.expertList = rows.map(item => ({
          id: item.id,
          name: item.title || item.name,
          org: item.description || item.summary || '',
          img: item.litpic ? JSON.parse(item.litpic)[0].url : ''
        }))
      } catch (e) {
        console.error('获取智库专家失败', e)
      }
    },
    async loadVideo() {
      const categoryId = getColumnIdByName('精彩视频')
      if (!categoryId) return
      try {
        const data = await contentList({ categoryId, pageNum: 1, size: 3 })
        const rows = data.rows || []
        this.videoList = rows.map(item => ({
          ...item,
          img: item.litpic ? JSON.parse(item.litpic)[0].url : ''
        }))
        console.log(12222, this.videoList)
      } catch (e) {
        console.error('获取精彩视频失败', e)
      }
    },
    async loadPhoto() {
      const categoryId = getColumnIdByName('精彩图集')
      if (!categoryId) return
      try {
        const data = await contentList({ categoryId, pageNum: 1, size: 4 })
        const rows = data.rows || []
        this.photoList = rows.map(item => ({
          ...item,
          img: item.litpic ? JSON.parse(item.litpic)[0].url : ''
        }))
      } catch (e) {
        console.error('获取精彩图集失败', e)
      }
    },
    async loadSupervising() {
      const categoryId = getColumnIdByName('上级指导单位')
      if (!categoryId) return
      try {
        const data = await contentList({ categoryId, pageNum: 1, size: 4 })
        const rows = data.rows || []
        this.supervisingList = rows
      } catch (e) {
        console.error('获取上级指导单位失败', e)
      }
    },
    
    goDetail(item) {
      if (item && item.id) {
        this.$router.push('/article/' + item.id)
      }
    }
  }
}
</script>
<style lang="scss" src="./assets/index.scss" />
